import { render } from "./AgregarArchivosConTipo.vue?vue&type=template&id=45910933&scoped=true"
import script from "./AgregarArchivosConTipo.vue?vue&type=script&lang=js"
export * from "./AgregarArchivosConTipo.vue?vue&type=script&lang=js"

import "./AgregarArchivosConTipo.vue?vue&type=style&index=0&id=45910933&scoped=true&lang=css"
import "../assets/general.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45910933"]])

export default __exports__